module.exports = __webpack_public_path__ + "static/img/97e21f8f61c7e11ca8d30f74b90fecea.index1.1709800931122.png";